export const SUID_ELEMENT = document.getElementById('suid')